require('./scroll');
const Velocity = require('velocity-animate');

var callback = function() {
  // Handler when the DOM is fully loaded
  toggleNav();
  petAccordion();
};

if (
  document.readyState === 'complete' ||
  (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
  callback();
} else {
  document.addEventListener('DOMContentLoaded', callback);
}

function toggleNav() {
  var hamburger = {
    htmlElement: document.querySelector('html'),
    navToggle: document.querySelector('.nav-trigger'),
    nav: document.querySelector('nav'),
    auxLink: document.querySelector('#cta-header-link'),

    doToggle: function() {
      this.htmlElement.classList.toggle('no-scroll');
      this.navToggle.classList.toggle('expanded');
      this.nav.classList.toggle('expanded');
      this.auxLink.classList.toggle('cta-link--light');
    },
  };

  hamburger.navToggle.addEventListener('click', function() {
    hamburger.doToggle();
  });
}

function petAccordion() {
  var acc = document.getElementsByClassName('accordion__title');
  var i, j;

  var accordionPanels = document.getElementsByClassName('accordion__panel');
  //   console.log(accordionPanels);

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener('click', function(e) {
      let targetValue = e.target;

      let event_label = targetValue.innerHTML.replace(/<{1}[^<>]{1,}>{1}/g, '');
      event_label = event_label.trim();

      gtag('event', 'click', {
        event_category: 'Accordion',
        event_label: event_label,
      });

      let target = e.target.closest('.accordion__item');

      var panel = this.nextElementSibling;
      //   console.log(panel.className);
      if (panel.className == 'accordion__panel active') {
        panel.className = 'accordion__panel ';
      } else {
        for (j = 0; j < acc.length; j++) {
          accordionPanels[j].className = 'accordion__panel';
        }
        if (panel.className == 'accordion__panel') {
          panel.className = 'accordion__panel active';
        }
      }

      setTimeout(function() {
        Velocity(target, 'scroll', { duration: 500 });
      }, 0);
    });
  }
}



// WEBPACK FOOTER //
// ./js/napcor.js